import React, { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import {
  getBinsVolume,
  getWorkingRoutesNodes,
} from "../../../redux/api/expedition.api";
import TableWidget from "../../../components/tables/TableWidget";
import {
  binsVolumeTableHeader,
  getBinsVolumeTableData,
} from "./components/tableConfigs/binsVolumeTableConfig";
import { TableActions } from "../../../components/tables/tableContext/TableContext";
import BinsVolumeActionButtons from "./components/ActionButtons/BinsVolumeActionButtons";

function BinsVolume() {
  const dispatch = useAppDispatch();

  const {
    expedition: {
      binsVolume: {
        data: { data: binsVolumeData, total: totalBinsVolume },
        isLoading: isLoadingBinsVolume,
      },
      workingRoutesNodes: {
        data: { data: clientsNodesData },
        isLoading: isLoadingNodes,
      },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  useEffect(() => {
    dispatch(
      getWorkingRoutesNodes({
        page: 1,
        perPage: 1000,
      }),
    );
  }, [dispatch]);

  const handleBinsVolumeTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch &&
      action.tableFilter
    ) {
      dispatch(
        getBinsVolume({
          page: action.tablePagination.page,
          per_page: action.tablePagination.rowsPerPage,
          nrVolum: action.tableSearch.nrVolum,
          nodDestinatie: action.tableFilter.nodDestinatie,
          nodPreluare: action.tableFilter.nodPreluare,
          status: action.tableFilter.status,
        }),
      );
    }
  };

  const binsVolumeTableHeaderNew = useMemo(
    () =>
      binsVolumeTableHeader.map((item) => {
        if (!isLoadingNodes && item.value === "nodDestinatie") {
          const nodesDropdown = clientsNodesData?.map(
            ({ nodNume, id_nod }) => ({
              label: nodNume,
              value: id_nod,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: 0 }, ...nodesDropdown],
            ...item,
          };
        }
        if (!isLoadingNodes && item.value === "nodPreluare") {
          const nodesDropdown = clientsNodesData?.map(
            ({ nodNume, id_nod }) => ({
              label: nodNume,
              value: id_nod,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: 0 }, ...nodesDropdown],
            ...item,
          };
        }
        return item;
      }),
    [clientsNodesData, isLoadingNodes],
  );

  return (
    <TableWidget
      tableTitle="Volume marfa"
      tableHeaderData={binsVolumeTableHeaderNew}
      tableItemsData={getBinsVolumeTableData(binsVolumeData)}
      totalItems={totalBinsVolume}
      tableLoading={isLoadingBinsVolume}
      handleTableActions={handleBinsVolumeTableActions}
      ActionButtonsComponent={BinsVolumeActionButtons}
      borderedRow
    />
  );
}

export default BinsVolume;
